import axios from 'axios'

// TEL-2243: sem normalizacao de erro de proposito. Este webhook e
// fire-and-forget para o n8n — a falha dele nao chega ao cliente e nao deve
// interromper o fluxo de quem salvou os dados.
export function triggerUserDataUpdateWebhook ({ email, name, phone, domain }) {
  const webhookUrl = process.env.API4COM_USER_DATA_UPDATE_WEBHOOK_URL
  if (!webhookUrl) {
    console.warn('api4com > user > data-update > webhook URL not configured (API4COM_USER_DATA_UPDATE_WEBHOOK_URL)')
    return Promise.resolve()
  }

  const payload = {
    email,
    nome: name,
    telefone: phone,
    dominio: domain
  }

  return new Promise((resolve) => {
    axios.post(webhookUrl, payload, {
      headers: { 'Content-Type': 'application/json' }
    })
      .then(() => {
        console.log('api4com > user > data-update > webhook sent successfully')
        resolve()
      })
      .catch(err => {
        console.error('api4com > user > data-update > webhook error', err)
        resolve()
      })
  })
}



// WEBPACK FOOTER //
// ./src/services/user-data-update-webhook.js